import { Map, OrderedSet } from 'immutable';

import * as types from './types';

const initialState = Map({
  testName: null,
  testHash: null,
  lines: OrderedSet(),
  annotationsName: null,
});

const rootCausesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_LOG_LINES.SUCCESS: {
      if (!Array.isArray(payload.results) || !payload.results.length) { return state; }

      // TODO in future payload.results will be an array with multiple patters
      const results = payload.results[0];
      const sortedLines = results.lines.sort((prev, next) => prev - next);
      const lines = OrderedSet(sortedLines);

      const annotationName = results.annotations && results.annotations.join(', ');

      return state.withMutations((newState) => {
        newState
          .set('lines', lines)
          .set('annotationsName', annotationName)
          .set('testName', results.test_name)
          .set('testHash', results.test_hash)
          .set('pattern', results.pattern);
      });
    }
    case types.GET_LOG_LINES.FAILURE:
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default rootCausesReducer;
export { initialState };
